import { render, staticRenderFns } from "./OnlineRoomsList.vue?vue&type=template&id=7983f8f0&"
import script from "./OnlineRoomsList.vue?vue&type=script&lang=js&"
export * from "./OnlineRoomsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports